(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trInterpolateDirective', trInterpolateDirective);

  function trInterpolateDirective(
    $interpolate,
    _
  ) {
    const directive = {
      restrict: 'A',
      scope: {
        codeSnippet: '=',
        jsTag: '<',
        campaignId: '<'
      },
      link: link
    };
    return directive;

    function link(scope, element) {
      let innerHTML = element[0].innerHTML;
      innerHTML = _.replace(innerHTML, new RegExp('{{vm.','g'), '{{');
      scope.codeSnippet = $interpolate(innerHTML)(scope);
    }
  }
})();
